module.exports = __webpack_public_path__ + "fonts/RobotoMono-Bold.4d2fbed1.woff2";